import { NgModule, Type } from '@angular/core';

import { CommonModule } from '@angular/common';
import { KnowledgeBodyTitleComponent } from './knowledge-body-title.component';

const components: Type<any>[] = [KnowledgeBodyTitleComponent];

@NgModule({
  imports: [CommonModule],
  declarations: [components],
  exports: [components],
})
export class KnowledgeBodyTitleModule { }
